import React from "react";
import {
  AHIcon,
  AHIconType,
  AHText,
  AHTextFonts,
  Box,
  TouchableBox,
  useCircleSize,
} from "arkh";

export function TodoEditNewPropertyItem(props: {
  icon: AHIconType;
  title: string;
  value: React.ReactNode;
  locked?: boolean;
  onPress?: () => void;
  onPressIn?: () => void;
  children?: React.ReactNode;
}) {
  const minHeight = useCircleSize("smallMedium");
  return (
    <TouchableBox
      space="medium"
      onPress={props.onPress}
      onPressIn={props.onPressIn}
      disabled={!props.onPress || props.locked}
    >
      <Box style={{ flexDirection: "row", alignItems: "flex-start", flex: 1 }}>
        <Box style={{ flexDirection: "row", alignItems: "center", minHeight }}>
          <AHIcon type={props.icon} size="medium" color="text-secondary" />
          <AHText
            size={11}
            font={AHTextFonts.BOLD}
            color="text-secondary"
            spaceHorizontal="small"
          >
            {props.title}
          </AHText>
        </Box>
        <Box
          style={{
            minHeight,
            flex: 1,
            justifyContent: "flex-end",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {props.value}
        </Box>
      </Box>
      {props.children}
    </TouchableBox>
  );
}
